import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import TreeMap from './TreeMap';

class MapsWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>US Sectors Heatmap</title>
          <link rel="canonical" href="https://www.vizfm.com/usSectorHeatmap" />
          <meta name="description" content="US stock sectors Heatmap " />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <h4>US Sectors Heatmap</h4>
          </Row>
          <Row>
            <TreeMap />
          </Row>
          <Row>
            <Col>
              <Button style={{backgroundColor:'darkgreen', fontSize: '10px'}} disabled>+3 %</Button>{' '}
              <Button style={{backgroundColor:'#329932', fontSize: '10px'}} disabled>+2 %</Button>{' '}
              <Button style={{backgroundColor:'#99cc99', fontSize: '10px'}} disabled>+1 %</Button>{' '}
              <Button style={{backgroundColor:'grey', fontSize: '10px'}} disabled>0 %</Button>{' '}
              <Button style={{backgroundColor:'#ffb2b2', fontSize: '10px'}} disabled>-1 %</Button>{' '}
              <Button style={{backgroundColor:'#ff6666', fontSize: '10px'}} disabled>-2 %</Button>{' '}
              <Button style={{backgroundColor:'red', fontSize: '10px'}} disabled>-3 %</Button>{' '}
            </Col>
          </Row>
          <Row>
            <Col style={{fontSize:'12px'}}>
            Use Mouse left(single finger on touch screen) click to expand and right click (two fingers on touch screen) to go back
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default MapsWrap;
